<template>
  <view-wrapper
    name="Integration Clients"
    :loading="loading"
    isFullSize
    :loadingText="loadingText"
  >
    <router-link
      class="mt-3 mb-6 button big primary white"
      to="integrationclients/add"
      >Add new client</router-link
    >
    <wrapper class="mb-5" :check-for-child-focused="true">
      <filter-and-sort-box
        :data="filteredIntegrationClients"
        :headers="headers"
        :useSearch="true"
        @searchQuery="searchText = $event"
        :columnsToNotSort="columnsToNotSort"
      >
        <template v-slot:rows="{ rows }">
          <tr class="bg-primary" v-for="(d, index) in rows" :key="index">
            <td
              class="py-2"
              :title="d[index]"
              :key="key + index1"
              v-for="(key, index1) in Object.keys(headers)"
            >
              {{ truncateText(34, d[key]) }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4 cursor-pointer hover:text-highlight"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                v-if="
                  key === 'displayClientId' || key === 'displayClientSecret'
                "
                @click="
                  copy(
                    d,
                    key === 'displayClientId' ? 'clientId' : 'clientSecret'
                  )
                "
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
            </td>
            <td class="p-2">
              <icon-button
                buttonType="link"
                tooltip="Edit"
                class="mr-2"
                @click="editIntegrationClient(d.id)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                  />
                </svg>
              </icon-button>
              <icon-button
                class="mr-2"
                tooltip="Delete"
                @click="setClientAsDelete(d)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  />
                </svg>
              </icon-button>
              <icon-button
                tooltip="Refresh keys"
                @click="setClientAsRefresh(d)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
              </icon-button>
            </td>
          </tr>
        </template>
      </filter-and-sort-box>
    </wrapper>
    <modal
      v-if="confirmRefreshOpen"
      @close="closeConfirmRefresh"
      type="success"
    >
      <template slot="header">
        <svg
          v-if="!isRefreshing"
          width="106"
          height="106"
          viewBox="0 0 106 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 53C0 23.744 23.744 0 53 0C82.256 0 106 23.744 106 53C106 82.256 82.256 106 53 106C23.744 106 0 82.256 0 53ZM7 52.5C7 78.1913 27.8088 99 53.5 99C79.1913 99 100 78.1913 100 52.5C100 26.8088 79.1913 6 53.5 6C27.8088 6 7 26.8088 7 52.5Z"
            fill="white"
          />
          <rect x="48" y="28" width="10" height="32" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53 78C56.3137 78 59 75.3137 59 72C59 68.6863 56.3137 66 53 66C49.6863 66 47 68.6863 47 72C47 75.3137 49.6863 78 53 78Z"
            fill="white"
          />
        </svg>
        <template v-if="isRefreshing">
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
        </template>
      </template>
      <template slot="body">
        <h3>Are you sure?</h3>
        <p>This action cannot be reverted</p>
      </template>
      <template slot="buttons">
        <grafokett-button
          class="mb-2 mr-4 button hover:text-highlight"
          @click="closeConfirmRefresh"
          >No</grafokett-button
        >
        <grafokett-button
          class="mb-2 text-white button bg-primary-light white"
          @click="refreshIntegrationClient()"
          >Yes</grafokett-button
        >
      </template>
    </modal>
    <modal v-if="confirmDeleteOpen" @close="closeConfirmDelete" type="warning">
      <template slot="header">
        <svg
          v-if="!isDeleting"
          width="106"
          height="106"
          viewBox="0 0 106 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 53C0 23.744 23.744 0 53 0C82.256 0 106 23.744 106 53C106 82.256 82.256 106 53 106C23.744 106 0 82.256 0 53ZM7 52.5C7 78.1913 27.8088 99 53.5 99C79.1913 99 100 78.1913 100 52.5C100 26.8088 79.1913 6 53.5 6C27.8088 6 7 26.8088 7 52.5Z"
            fill="white"
          />
          <rect x="48" y="28" width="10" height="32" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53 78C56.3137 78 59 75.3137 59 72C59 68.6863 56.3137 66 53 66C49.6863 66 47 68.6863 47 72C47 75.3137 49.6863 78 53 78Z"
            fill="white"
          />
        </svg>
        <template v-if="isDeleting">
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
          <span class="loading-span"></span>
        </template>
      </template>
      <template slot="body">
        <h3>Are you sure?</h3>
        <p>This action cannot be reverted</p>
      </template>
      <template slot="buttons">
        <grafokett-button
          class="mb-2 mr-4 button hover:text-highlight"
          @click="closeConfirmDelete"
          >No</grafokett-button
        >
        <grafokett-button
          class="mb-2 button primary white"
          @click="deleteIntegrationClient()"
          >Yes</grafokett-button
        >
      </template>
    </modal>
  </view-wrapper>
</template>

<script>
import FilterAndSortBox from "../../components/FilterAndSortBox";
import Wrapper from "../../components/Wrapper";
import Modal from "../../components/Modal";
import GrafokettButton from "../../components/forms/Button";
import { truncuateString } from "../../utils/stringHelpers";
import IconButton from "../../components/IconButton.vue";

export default {
  components: {
    FilterAndSortBox,
    Wrapper,
    Modal,
    GrafokettButton,
    IconButton,
  },
  data() {
    return {
      loading: false,
      isDeleting: false,
      idToDelete: null,
      confirmDeleteOpen: false,
      isRefreshing: false,
      confirmRefreshOpen: false,
      idToRefresh: null,
      loadingText: "List of integrationclients",
      searchText: "",
      headers: {
        name: "Name",
        description: "Description",
        displayClientId: "ClientId",
        displayClientSecret: "ClientSecret",
        groups: "Default Groups",
        actions: "",
      },
      columnsToNotSort: ["actions"],
      integrationClients: [],
    };
  },
  async beforeMount() {
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;

      const response = await this.$store.$api.get("/api/integrationclient");

      this.integrationClients = response.data.data;

      this.integrationClients.forEach(client => {
        client.displayClientId = truncuateString(client.clientId, 17);
        client.displayClientSecret = truncuateString(client.clientSecret, 17);
        client.groups =
          client.integrationClientGroups &&
          client.integrationClientGroups.length > 0
            ? client.integrationClientGroups.length > 1
              ? `${client.integrationClientGroups[0].group.name}... +${client
                  .integrationClientGroups.length - 1}`
              : client.integrationClientGroups[0].group.name
            : "Any";
      });

      this.loading = false;
    },
    truncateText(ellipsisPosition, text) {
      if (!text) return "-";
      if (text.length > ellipsisPosition)
        return text.substring(0, ellipsisPosition) + "...";
      else return text;
    },
    async deleteIntegrationClient() {
      this.isDeleting = true;
      await this.$store.$api.delete(
        `/api/integrationclient/${this.idToDelete}`
      );
      this.isDeleting = false;
      this.integrationClients = [
        ...this.integrationClients.filter(x => x.id !== this.idToDelete),
      ];
      this.closeConfirmDelete();
    },
    setClientAsDelete(client) {
      this.idToDelete = client.id;
      this.confirmDeleteOpen = true;
    },
    editIntegrationClient(id) {
      this.$router.push(`integrationclients/${id}/edit`);
    },
    closeConfirmDelete() {
      this.idToDelete = null;
      this.confirmDeleteOpen = false;
    },
    setClientAsRefresh(client) {
      this.idToRefresh = client.id;
      this.confirmRefreshOpen = true;
    },
    closeConfirmRefresh() {
      this.idToRefresh = null;
      this.confirmRefreshOpen = false;
    },
    async refreshIntegrationClient() {
      this.isRefreshing = true;

      const { data: data } = await this.$store.$api.put(
        "/api/integrationclient/keys",
        { id: this.idToRefresh }
      );

      const client = this.integrationClients.find(
        x => x.id === this.idToRefresh
      );

      const { clientId, clientSecret } = data;

      client.clientId = clientId;
      client.clientSecret = clientSecret;
      client.displayClientId = truncuateString(clientId, 17);
      client.displayClientSecret = truncuateString(clientSecret, 17);

      this.isRefreshing = false;
      this.closeConfirmRefresh();
    },
    async copy(data, key) {
      const cb = navigator.clipboard;
      await cb.writeText(data[key]);
    },
  },
  computed: {
    filteredIntegrationClients() {
      if (!this.searchText || this.searchText.length <= 0)
        return this.integrationClients;

      return this.integrationClients.filter(
        x => x.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      );
    },
  },
};
</script>

<style lang="postcss" scoped>
.loading-span {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  animation: rotate 2s linear infinite both;
}

.loading-span:nth-of-type(1) {
  animation-delay: 0.2s;
}

.loading-span:nth-of-type(2) {
  animation: rotate 2s 0.4s linear infinite both;
}

.loading-span:nth-of-type(3) {
  animation: rotate 2s 0.6s linear infinite both;
}

.loading-span:nth-of-type(4) {
  animation-delay: 0.8s;
}

.loading-span:nth-of-type(5) {
  animation-delay: 1s;
}

@keyframes rotate {
  from {
    transform: rotate(0deg) translateY(-200%) rotate(0deg) scale(0.2);
  }
  50% {
    transform: rotate(360deg) translateY(-200%) rotate(-360deg) scale(1);
  }

  to {
    transform: rotate(360deg) translateY(-200%) rotate(-360deg) scale(0);
  }
}

td:first-of-type {
  @apply pl-2;
}

td:last-of-type {
  @apply pr-2;
}
</style>
